module.exports = __webpack_public_path__ + "img/timikeys.live.png.04adec54.webp";